module.exports = __webpack_public_path__ + "img/welcome.3500bc07.jpg";